import React from "react";
import * as constants from "../constants";


const Logo = (props) => {

  let src = constants.HERTZ_URL_LOGO;

  if(props.brand == 'Ace'){
    src = constants.ACE_URL_LOGO;
  }
  else if(props.brand == 'Firefly'){
    src=constants.FIREFLY_URL_LOGO;
  }
  else if(props.brand == 'Dollar'){
    src=constants.DOLLAR_URL_LOGO;
  }
  else if(props.brand == "Thrifty"){
    src=constants.THRIFTY_URL_LOGO;
  }


  return (
    <img
      alt="Logo"
      src= {src}
      {...props}
    />
  );
};

export default Logo;
